import { useCallback, useMemo } from 'react';
import Raven from 'raven-js';
import { isUngatedToCHIRPEndpoints } from '../utils/gates';
import { useGetDocumentAnalyticsSummaryQuery } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsAnalyticsService.hooks';
export const useGetSummaryAnalytics = ({
  documentId
}) => {
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const handleSummaryAnalyticsError = useCallback(error => {
    Raven.captureException(error, {
      extra: {
        documentId
      }
    });
  }, [documentId]);
  const {
    data,
    loading,
    error
  } = useGetDocumentAnalyticsSummaryQuery({
    variables: {
      documentId: documentId
    },
    skip: !isUngatedToChirp || !documentId,
    onError: handleSummaryAnalyticsError
  });
  const payload = useMemo(() => {
    return {
      data,
      loading,
      error
    };
  }, [data, loading, error]);
  return payload;
};